__turbopack_context__.v({
  "input": "OgshXW_input",
  "label": "OgshXW_label",
  "required": "OgshXW_required",
  "root": "OgshXW_root",
});
